import { render } from "./MGXYView.vue?vue&type=template&id=f48bf2f0&scoped=true"
import script from "./MGXYView.vue?vue&type=script&lang=js"
export * from "./MGXYView.vue?vue&type=script&lang=js"

import "./MGXYView.vue?vue&type=style&index=0&id=f48bf2f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f48bf2f0"]])

export default __exports__